// Hook for the message form - scrolls to bottom when submitting
const MessageForm = {
  mounted() {
    this.el.addEventListener('submit', () => {
      // Scroll to bottom immediately when user submits a message
      const scrollContainer = document.getElementById('messages-scroll-container');
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: 'smooth'
        });
      }
    });
  }
};

export default MessageForm;
